import { Store } from 'vuex';
import AuthStore from '../modules/AuthStore';

declare global {
	// eslint-disable-next-line
	interface Window { pendo: any }
}

const pendoPlugin = (store: Store<Record<string, unknown>>) => {
	
	const unsubscribe = store.subscribe((mutation, state) => {
		
		if (window.pendo === undefined) {
			unsubscribe();
			return;
		}
		
		if (mutation.type == 'auth/setSessionData') {
			const auth: AuthStore = state.auth as AuthStore;

			// undefined check for typescriptiness
			if (auth.sessionData === undefined || auth.headerData === undefined) {
				// try again on next mutation
				return;
			}

			const fullName = auth.sessionData.firstName + ' ' + auth.sessionData.lastName;
			const config = {
				visitor: {
					id: auth.sessionData.id,
					email: auth.sessionData.email,
					"full_name": fullName,
					"visitor_type": auth.sessionData.fkAuthLevel
				},

				account: {
					id: auth.headerData.ownerFi ? auth.headerData.ownerFi.fiId : 0,
					name: auth.headerData.ownerFi ? auth.headerData.ownerFi.name : "Kasasa"
				}
			};
			
			// initialize the pendo tracker
			window.pendo.initialize(config);
			
			// calling same, pops it off the listener array
			unsubscribe();
		}
	});
};

export default pendoPlugin;
